<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        sm6
        xs12
        md4
        lg4>
        <v-menu
          ref="menu1"
          :close-on-content-click="false"
          v-model="menu1"
          :nudge-right="40"
          :return-value.sync="scheduleDateFrom"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="scheduleDateFromFormatted"
            label="Start Date"
            prepend-icon="mdi-calendar"
            readonly
          />
          <v-date-picker
            v-model="scheduleDateFrom"
            no-title
            @input="$refs.menu1.save(scheduleDateFrom)"
            min="2020-01-01"/>
        </v-menu>

        <v-menu
            ref="menu2"
            :close-on-content-click="false"
            v-model="menu2"
            :nudge-right="40"
            :return-value.sync="scheduleDateTo"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
        >
          <v-text-field
              slot="activator"
              v-model="scheduleDateToFormatted"
              label="End Date"

              prepend-icon="mdi-calendar"
              readonly
          />
          <v-date-picker
              v-model="scheduleDateTo"
              no-title
              @input="$refs.menu2.save(scheduleDateTo)"
              min="2020-01-01"/>
        </v-menu>
      </v-flex>

      <v-flex
      v-if="loginType == 'client'"
        sm6
        xs12
        md4
        lg4>
        <v-select
          :items="this.$store.state.stateList"
          v-model="stateFilter"
          label="State" />

        <v-select
          :items="this.$store.state.workOrders"
          v-model="workOrderFilter"
          label="Work Orders" 
          item-text="displayText"
          item-value="value"
          class="work-order-select"
        />
      </v-flex>

      <v-flex
        v-if="loginType == 'client'"
        sm6
        xs12
        md4
        lg4>
         <!-- distributorView temporarily disabled while we address a data issue -->
         <v-select
          v-if="distributorView == '1'"
          :items="this.$store.state.distributorsList"
          v-model="distributorFilter"
          label="Distributor"
          item-text="name"
          item-value="name"
        />
        <v-select
          :items="this.$store.state.storeTypes"
          v-model="storeFilter"
          label="Retailer" />
        <v-select
          :items="this.$store.state.brandsList"
          v-model="brandFilter"
          label="Brand"
          item-text="name"
          item-value="name"
        />
      </v-flex>

      <v-flex
        v-if="loginType == 'retail'"
        sm6
        xs12
        md4
        lg4>
        <v-select
          :items="this.$store.state.stateList"
          v-model="stateFilter"
          label="State" />
      </v-flex>

      <v-flex
        xs12
        class="schedule-action-row"
      >
        <v-btn
          :loading="csvExporting"
          :disabled="csvExporting"
          @click.native="exportScheduleCSV"
          medium
          class="mr-3 ml-4"
        >
          <v-icon medium color="dark_grey">mdi-cloud-download</v-icon> &nbsp;&nbsp; Download CSV
        </v-btn>
        <v-btn
          @click.native="copyUrl"
          medium
        >
          <v-icon medium color="dark_grey">mdi-link-variant</v-icon> &nbsp;&nbsp; Copy Schedule Link
        </v-btn>
      </v-flex>

      <v-flex
      md12
      lg12
      >

      <!-- 3P SCHEDULE WITH DEMO_ID -->
      <v-flex
        v-if="loginType == 'client' && startsWith3P(company)"
      >
          <material-card
          color="secondary"
          title="Schedule"
          text="Real-time shift information - Email events@hspbrands.com with updates or questions. Events subject to change."
          >
              <v-data-table
                  :headers="headers3P"
                  :items="this.$store.state.schedule"
                  disable-initial-sort
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
              >
                  <template
                  slot="headerCell"
                  slot-scope="{ header }"
                  >
                  <span
                      class="text--darken-3"
                      v-text="header.text"
                  />
                  </template>
                  <template
                  slot="items"
                  slot-scope="{item }"
                  >

                  <td>{{ item.subaccount}}</td>
                  <td>
                    <div v-for="wine in item.wines" :key="wine">• {{ safeTrim(wine) }}</div>
                  </td>
                  <td>
                    <div v-for="sub_wine in item.sub_wines" :key="sub_wine">• {{ safeTrim(sub_wine) }}</div>
                  </td>
                  <td>{{ item.storename }}</td>
                  <td class="text-xs-right">{{ item.warehouse_id }}</td>
                  <td>{{ formatDate(item.schedule_date) + "\n" + formatTime(item.time_start) + "-\n" +  formatTime(item.time_end)  }}</td>
                  <td>{{ item.city }}</td>
                  <td>{{ item.state }}</td>
                  <td>{{ item.store_type }}</td>
                  <td>{{ item.client_code + "_" + item.schedule_id }}</td>
                  </template>
              </v-data-table>
          </material-card>
        </v-flex>

        <!-- CLIENT SCHEDULE TABLE -->
        <v-flex v-if="loginType == 'client' && clientSchedule.length && !startsWith3P(company)">
        <material-card
          color="secondary"
          title="HSP Schedule"
          text="Real-time shift information - Email events@hspbrands.com with updates or questions. Events subject to change."
        >
          <v-data-table
            :headers="headers"
            :items="clientSchedule"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{item}">
              
              <td>{{ item.subaccount }}</td>
              <td class="wines-column">
                <div v-for="wine in item.wines" :key="wine">• {{ safeTrim(wine) }}</div>
              </td>
              <td class="sub-wines-column">
                <div v-for="sub_wine in item.sub_wines" :key="sub_wine">• {{ safeTrim(sub_wine) }}</div>
              </td>
              <td>{{ item.storename }}</td>
              <td class="text-xs-right">{{ item.warehouse_id }}</td>
              <td>{{ formatDay(item.DOW) }}</td>
              <td>{{ formatDate(item.schedule_date) + "\n" + formatTime(item.time_start) + "-\n" +  formatTime(item.time_end)  }}</td>
              <td>{{ item.city }}</td>
              <td>{{ item.state }}</td>
              <td>{{ item.store_type }}</td>
              <td>{{ item.work_order }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <!-- RETAIL SCHEDULE TABLE -->
      <v-flex v-if="loginType == 'retail'">
        <material-card
          color="secondary"
          title="HSP Schedule"
          text="Real-time shift information - Email events@hspbrands.com with updates or questions. Events subject to change."
        >
          <v-data-table
            :items="this.$store.state.schedule"
            :headers="headersRetail"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{item}">
              <td>{{ item.subaccount }}</td>
              <td class="wines-column">
                <div v-for="wine in item.wines" :key="wine">• {{ safeTrim(wine) }}</div>
              </td>
              <td class="sub-wines-column">
                <div v-for="sub_wine in item.sub_wines" :key="sub_wine">• {{ safeTrim(sub_wine) }}</div>
              </td>
              <td>{{ item.storename }}</td>
              <td class="text-xs-right">{{ item.warehouse_id }}</td>
              <td>{{ formatDate(item.schedule_date) + "\n" + formatTime(item.time_start) + "-\n" +  formatTime(item.time_end)  }}</td>
              <td>{{ item.city }}</td>
              <td>{{ item.state }}</td>
              <td>{{ item.store_type }}</td>
              <td>{{ item.work_order }}</td>
              <td>{{ item.client_name }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <!-- AGENCY SCHEDULE TABLE -->
      <v-flex v-if="loginType == 'client' && agencySchedule.length">
        <material-card
          color="secondary"
          title="Agency Schedule"
          text="Real-time shift information - Email events@hspbrands.com with updates or questions. Events subject to change."
        >
          <v-data-table
            :headers="headersAgency"
            :items="agencySchedule"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{item}">
              <td>{{ item.subaccount }}</td>
              <td class="wines-column">
                <div v-for="wine in item.wines" :key="wine">• {{ wine.trim() }}</div>
              </td>
              <td class="sub-wines-column">
                <div v-for="sub_wine in item.sub_wines" :key="sub_wine">• {{ sub_wine.trim() }}</div>
              </td>
              <td>{{ item.storename }}</td>
              <td>{{ (item.client_name) }}</td>
              <td>{{ formatDate(item.schedule_date) + "\n" + formatTime(item.time_start) + "-\n" +  formatTime(item.time_end)  }}</td>
              <td>{{ item.city }}</td>
              <td>{{ item.state }}</td>
              <td>{{ item.store_type }}</td>
              <td>{{ item.work_order }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-flex>
    </v-layout>
  </v-container>
</template>
  
<script>
import {TokenService} from "../services/storage.service";

export default {
  data () {
    return {
      menu2: false,
      menu1: false,
      csvExporting: false,
      rowsPerPageItems: [10, 30, 50, 100],
      pagination: {
        rowsPerPage: 30
      },

      headers: [
        {
          sortable: true,
          text: 'Event Type',
          value: 'subaccount'
        },
        {
          sortable: true,
          text: 'Product',
          value: 'wines'
        },
        {
          sortable: true,
          text: 'Substitutions',
          value: 'wine_subs',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Store Name',
          value: 'storename',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Store #',
          value: 'warehouse_id',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Day',
          value: 'DOW',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Shift',
          value: 'schedule_date',
        },
        {
          sortable: true,
          text: 'City',
          value: 'city',
        },
        {
          sortable: true,
          text: 'State',
          value: 'state',
        },
        {
          sortable: true,
          text: 'Store Type',
          value: 'store_type',
        },
        {
          sortable: true,
          text: 'Work Order',
          value: 'work_order',
        }
      ],

      headersAgency: [
        {
          sortable: true,
          text: 'Event Type',
          value: 'subaccount'
        },
        {
          sortable: true,
          text: 'Product',
          value: 'wines'
        },
        {
          sortable: true,
          text: 'Substitutions',
          value: 'wine_subs',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Store Name',
          value: 'storename',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Agency',
          value: 'client_name',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Shift',
          value: 'schedule_date',
        },
        {
          sortable: true,
          text: 'City',
          value: 'city',
        },
        {
          sortable: true,
          text: 'State',
          value: 'state',
        },
        {
          sortable: true,
          text: 'Store Type',
          value: 'store_type',
        },
        {
          sortable: true,
          text: 'Work Order',
          value: 'work_order',
        }
      ],

      headers3P: [
        {
          sortable: true,
          text: 'Event Type',
          value: 'subaccount'
        },
        {
          sortable: true,
          text: 'Product',
          value: 'wines'
        },
        {
          sortable: true,
          text: 'Substitutions',
          value: 'wine_subs',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Store Name',
          value: 'storename',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Store #',
          value: 'warehouse_id',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Shift',
          value: 'schedule_date',
        },
        {
          sortable: true,
          text: 'City',
          value: 'city',
        },
        {
          sortable: true,
          text: 'State',
          value: 'state',
        },
        {
          sortable: true,
          text: 'Store Type',
          value: 'store_type',
        },
        {
          sortable: true,
          text: 'Demo ID',
          value: 'demo_id'
        }
      ],

      headersRetail: [
        {
          sortable: true,
          text: 'Event Type',
          value: 'subaccount'
        },
        {
          sortable: true,
          text: 'Product',
          value: 'wines',
          width: '320px',
          itemClass: 'wines-column'
        },
        {
          sortable: true,
          text: 'Substitutions',
          value: 'sub_wines',
          align: 'left',
          width: '320px',
          itemClass: 'sub-wines-column'
        },
        {
          sortable: true,
          text: 'Store Name',
          value: 'storename',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Store #',
          value: 'warehouse_id',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Shift',
          value: 'schedule_date',
        },
        {
          sortable: true,
          text: 'City',
          value: 'city',
        },
        {
          sortable: true,
          text: 'State',
          value: 'state',
        },
        {
          sortable: true,
          text: 'Store Type',
          value: 'store_type',
        },
        {
          sortable: true,
          text: 'Work Order',
          value: 'work_order',
        },
        {
          sortable: true,
          text: 'Supplier',
          value: 'client_name'
        }  
      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      }
    }
  },
  computed: {
    scheduleDateFromFormatted () {
      return this.formatDate(this.scheduleDateFrom)
    },
    scheduleDateToFormatted () {
      return this.formatDate(this.scheduleDateTo)
    },
    demos () {
      return '' + this.$store.state.statistics.demos
    },
    authenticated () {
      return this.$store.state.accessKey != null && this.$store.state.authenticating == false
    },
    stateFilter: {
      get () {
        return this.$store.state.stateFilter
      },
      set (value) {
        this.$store.commit('setStateFilter', value)
      }
    },
    storeFilter: {
      get () {
        return this.$store.state.storeFilter
      },
      set (value) {
        this.$store.commit('setStoreFilter', value)
      }
    },
    workOrderFilter: {
      get () {
        return this.$store.state.workOrderFilter
      },
      set (value) {
        this.$store.commit('setWorkOrderFilter', value)
      }
    },
    distributorFilter: {
      get () {
        return this.$store.state.distributorFilter
      },
      set (value) {
        this.$store.commit('setDistributorFilter', value)
      }
    },
    brandFilter: {
      get () {
        return this.$store.state.brandFilter
      },
      set (value) {
        this.$store.commit('setBrandFilter', value)
      }
    },
    scheduleDateFrom: {
      get () {
        return this.$store.state.scheduleDateFrom
      },
      set (value) {
        this.$store.commit('setScheduleDateFrom', value)
      }
    },  
    scheduleDateTo: {
      get () {
        return this.$store.state.scheduleDateTo
      },
      set (value) {
        this.$store.commit('setScheduleDateTo', value)
      }
    },
    loginType () {
      return this.$store.state.login_type
    },
    distributorView () {
      return this.$store.state.distributorView
    },
    company () {
      return this.$store.state.company_name
    },
    clientSchedule () {
      return this.$store.state.schedule.filter(item => item.event_type === 'client')
    },
    agencySchedule () {
      return this.$store.state.schedule.filter(item => item.event_type === 'agency')
    }
  },
  watch: {
    scheduleDateFrom (val) {
      if (this.scheduleDateTo != null) {
        this.getWorkOrders()
        this.getStates()
        this.getSchedule()
        this.getStoreTypes()
      }
    },

    scheduleDateTo (val) {
      if (this.scheduleDateFrom != null) {
        this.getWorkOrders()
        this.getStates()
        this.getSchedule()
        this.getStoreTypes()
      }
    },

    authenticated (val) {
      if (this.authenticated) {
        this.getSchedule()
      }
    },

    stateFilter (val) {
      this.getSchedule()
    },

    storeFilter (val) {
      this.getSchedule()
    },

    workOrderFilter (val) {
      this.getSchedule()
    },

    distributorFilter (val) {
      this.getSchedule()
    },

    brandFilter (val) {
      this.getSchedule()
    }
  },
  created: function () {
    if (this.authenticated) {
      this.getWorkOrders()
      this.getStates()
      this.$store.dispatch('get_storeTypes', { dateStart: this.scheduleDateFrom, dateEnd: this.scheduleDateTo })

      if (!this.$store.state.distributorsList || this.$store.state.distributorsList.length === 0) {
        this.$store.dispatch('get_distributors')
      }

      if (!this.$store.state.brandsList || this.$store.state.brandsList.length === 0) {
        this.$store.dispatch('get_brands')
      }

      this.getSchedule()
    }
  },
  methods: {

    // Trims strings and safely handles non-strings
    safeTrim (value) {
      if (typeof value === 'string') return value.trim()
      return String(value == null ? '' : value).trim()
    },

    async copyUrl () {
      try {
        const response = await this.$store.dispatch('generateShareToken', {
          dateStart: this.$store.state.scheduleDateFrom,
          dateEnd: this.$store.state.scheduleDateTo,
          state: this.$store.state.stateFilter,
          workOrder: this.$store.state.workOrderFilter,
          brand: this.$store.state.brandFilter,
          distributor: this.$store.state.distributorFilter,
          store: this.$store.state.storeFilter
        })

        const baseUrl = window.location.origin
        const url = `${baseUrl}/shared-schedule?token=${response.token}`

        // navigator.clipboard requires HTTPS or localhost
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = url
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
      } catch (err) {
        console.error('Failed to generate or copy share link:', err)
      }
    },

    exportScheduleCSV () {
      this.csvExporting = true
      var context = this
      const params = new URLSearchParams({
        access_key: TokenService.getAccessKey(),
        filetype: 'csv',
        date_start: this.$store.state.scheduleDateFrom,
        date_end: this.$store.state.scheduleDateTo
      })

      if (this.$store.state.stateFilter && this.$store.state.stateFilter !== 'All') {
        params.append('state', this.$store.state.stateFilter)
      }

      if (this.$store.state.storeFilter && this.$store.state.storeFilter !== 'All') {
        params.append('store', this.$store.state.storeFilter)
      }

      if (this.$store.state.workOrderFilter && this.$store.state.workOrderFilter !== 'All') {
        params.append('work_order', this.$store.state.workOrderFilter)
      }

      if (this.$store.state.distributorFilter && this.$store.state.distributorFilter !== 'All') {
        params.append('distributor', this.$store.state.distributorFilter)
      }

      if (this.$store.state.brandFilter && this.$store.state.brandFilter !== 'All') {
        params.append('brand', this.$store.state.brandFilter)
      }

      var login_type = ""
      if (this.$store.state.login_type == 'client') {
          login_type = "clients/"
      } else {
        login_type = "retail/"
      }
      var url = this.$store.state.apiRoot  + login_type + TokenService.getLoginCode() + '/schedule?' + params.toString()
      window.location.href = url
      setTimeout(function () {
        context.csvExporting = false
      }, 3500)
    },

    getSchedule: function () {
      if (this.$store.state.login_type == 'client') {
        this.$store.dispatch('get_schedule', {dateStart: this.scheduleDateFrom, dateEnd: this.scheduleDateTo, state: this.stateFilter, workOrder: this.workOrderFilter, distributor: this.distributorFilter, brand: this.brandFilter, store: this.storeFilter})
      } else {
        this.$store.dispatch('get_schedule', {dateStart: this.scheduleDateFrom, dateEnd: this.scheduleDateTo, state: this.stateFilter})
      }
    },

    // Pull active work orders; reset to 'ALL' if selection isn't valid
    getWorkOrders: function () {
      if (this.$store.state.login_type == 'client') {
        const currentFilter = this.$store.state.workOrderFilter
        
        this.$store.dispatch('get_workOrders', {
          dateStart: this.scheduleDateFrom, 
          dateEnd: this.scheduleDateTo
        }).then(() => {
          const workOrderExists = this.$store.state.workOrders.some(
            wo => wo.value === currentFilter
          )
          
          if (!workOrderExists) {
            this.$store.commit('setWorkOrderFilter', 'All')
          }
        })
      }
    },

    getStates: function () {
      this.$store.dispatch('get_states', {dateStart: this.scheduleDateFrom, dateEnd: this.scheduleDateTo})
    },

    getStoreTypes: function () {
      this.$store.dispatch('get_storeTypes', {dateStart: this.scheduleDateFrom, dateEnd: this.scheduleDateTo})
    },

    complete (index) {
      this.list[index] = !this.list[index]
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatTime (time) {
      var [hour, minute, second] = time.split(':')
      var meridian = ' AM'
      if (hour >= 12) {
        meridian = ' PM'
      }
      if (hour > 12) {
        hour = hour - 12
      }
      return '' + hour + ':' + minute + meridian
    },

    formatDay (dow) {
      switch (dow) {
        case "7":
          return "Sunday"
        case "1":
          return "Monday"
        case "2":
          return "Tuesday"
        case "3":
          return "Wednesday"
        case "4":
          return "Thursday"
        case "5":
          return "Friday"
        case "6":
          return "Saturday"
      }
    },

    startsWith3P (clientName) {
      return clientName.startsWith('3P')
    }
  }
}
</script>
  
<style scoped>

.work-order-select >>> .v-select__selection {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.wines-column {
  min-width: 320px;
  max-width: 400px;
  white-space: normal;
  word-break: break-word;
}

.sub-wines-column {
  min-width: 230px;
  max-width: 280px;
  white-space: normal;
  word-break: break-word;
}

.schedule-action-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

</style>